import { render, staticRenderFns } from "./IconTranslateSolid.vue?vue&type=template&id=bfe1dc80"
import script from "./IconTranslateSolid.vue?vue&type=script&lang=js"
export * from "./IconTranslateSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports